import './Checkbox.scss';
import { Icon } from '../Icon';

export const Checkbox = ({checked = false, onCheck = () => {}}) => {
    return (
        <Icon 
            size='1.5rem'
            className="Checkbox"
            color='#999'
            name={`square${checked ? '-check' : ''}`}
            onClick={onCheck}
        />
    );
};